import React, { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import searchIcon from '../../assets/icons/search.svg';

interface SearchInputProps {
  value: string;
  onChange: (query: string) => void;
  onClear: () => void;
  onSearch: (query: string) => void; // Nova prop para quando pressionar Enter
  placeholder: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
  onSearch,
  placeholder
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedQuery = inputValue.trim();
      if (trimmedQuery) {
        onSearch(trimmedQuery);
      }
    }
  };

  const handleClear = () => {
    setInputValue('');
    onClear();
  };

  return (
    <div className="relative mb-6">
      <div className="relative">
        <img
          src={searchIcon}
          alt="Search"
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white/60 w-5 h-5"
        />
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="w-full bg-white/5 border border-white rounded-xl py-2.5 pl-12 pr-12 text-white text-[12px] placeholder-white/60 focus:outline-none transition-all duration-200 font-sans"
        />
        {inputValue && (
          <button
            onClick={handleClear}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white/60 hover:text-white transition-colors duration-200"
            aria-label="Clear search"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
}; 